<script setup lang="ts">
import {useModalStore} from '../../../store/modal'
import {useCallStore} from '../../../store/calls';
import {useAuthStore} from '../../../store/auth';
import {computed, reactive} from "vue";

const store = useCallStore()
const modalStore = useModalStore()
const authStore = useAuthStore()
const isAdmin = computed(() => ['reseller-super-admin', 'reseller-team-leader', 'super-admin', 'internal-super-admin'].includes(authStore.user.roles[0].name))
const callParams = reactive({
    sort_direction: 'desc',
    assignee_id: isAdmin.value ? null : authStore.user.id,
    call_type: null,
    limit: 25,
    start_date: null,
    end_date: null
})
</script>

<template>
<div class="filters-modal-container">
    <div class="filters-modal-header">
        <button class="filters-modal-header-cross-button" @click="modalStore.close()">
            <ah-icon name="cross-default" :size="24"/>
        </button>
    </div>
    <div class="filters-modal-body">
        <div class="filters-modal-content">
            <div class="filters-modal-content-heading">
                <p>Filters.</p>
                <button>Clear</button>
            </div>

            <brand-form-select label="Sorting." :options="store.filter_data?.sorting ?? []" />
            <brand-form-select label="Assignee." :options="store.filter_data?.assignees ?? []" />
            <brand-form-select label="Call Type." :options="store.filter_data?.call_types ?? []" />


             <div class="filters-modal-content-heading">
                <p>Date.</p>
                <button>Clear</button>
            </div>

            <brand-form-input label="Start date." variant="date" v-model="callParams.start_date" />
            <brand-form-input label="End date." variant="date" v-model="callParams.end_date" />

        </div>

        <div class="filters-modal-actions">
            <brand-button>Apply</brand-button>
        </div>
    </div>
</div>
</template>

<style scoped lang="scss">

</style>
